

















import Vue from "vue";
import { Component } from "vue-property-decorator";
import FormItem from '@/components/Money/FormItem.vue'
import Button from "@/components/Button.vue"

import checkName from '@/lib/checkName'

@Component({
  components: {
    FormItem,
    Button
  },
})
export default class EditLabel extends Vue {
  get currentTag() {
    return this.$store.state.currentTag
  }

  get tagList() {
    return this.$store.state.tagList
  }

  created() {
    this.$store.commit('fetchTags')
    this.$store.commit('setCurrentTag', this.$route.params.id)
    if (!this.currentTag) {
      this.$router.replace("/404");
    }
  }

  update(name: string) {
    this.$store.commit('updateTag', name)
  }

  save() {
    if (!checkName(this.currentTag.name)) {
      return window.alert('标签名不能为空')
    } else {
      this.$store.commit('saveTag')
    }
  }

  remove() {
    this.$store.commit('removeTag')
  }

  goBack() {
    this.$router.back()
  }
}
